export default __webpack_public_path__ + "static/media/timetable_graphic.7c90ceb9.svg";